export default __webpack_public_path__ + "static/media/dolphin2.fa0223ce.png";